import React, { useEffect, useRef, useState } from 'react';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-logo" onClick={() => scrollTo('hero')}>
        <img src="/logo.jpg" alt="KroMaker" />
        <span>KroMaker</span>
      </div>
      <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        <button onClick={() => scrollTo('services')}>Servizi</button>
        <button onClick={() => scrollTo('projects')}>Progetti</button>
        <button onClick={() => scrollTo('blog')}>Blog</button>
        <button onClick={() => scrollTo('contact')} className="cta">Contattaci</button>
      </div>
      <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
        <span /><span /><span />
      </button>
    </nav>
  );
};

export default Navbar;
